import * as React from 'react';

function SvgLeaderboard(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="leaderboard_svg__a">
          <path
            d="M0 0h24v24H0z"
            data-name="Rectangle 300"
            transform="translate(116 758)"
            fill="#fff"
            stroke="#fff"
          />
        </clipPath>
      </defs>
      <g transform="translate(-116 -758)" clipPath="url(#leaderboard_svg__a)">
        <g fill="#fff">
          <path
            d="M125.035 764.262l-.442 2.577a.688.688 0 001 .726l2.313-1.215 2.315 1.212a.687.687 0 00.32.079.689.689 0 00.67-.842l-.434-2.537 1.872-1.825a.688.688 0 00-.381-1.175l-2.588-.376-1.154-2.342a.688.688 0 00-1.234 0l-1.16 2.344-2.588.374a.688.688 0 00-.381 1.174zm1.653-2.065a.688.688 0 00.518-.376l.7-1.419.7 1.419a.689.689 0 00.518.376l1.566.228-1.133 1.1a.688.688 0 00-.2.609l.269 1.565-1.4-.737a.687.687 0 00-.64 0l-1.4.736.267-1.559a.688.688 0 00-.2-.609l-1.127-1.104z"
            data-name="Path 369"
          />
          <path
            d="M137.121 773.641h-2.948a2.512 2.512 0 00-1.155.28v-2.172a2.534 2.534 0 00-2.531-2.531h-5.161a2.534 2.534 0 00-2.531 2.531v.329a2.519 2.519 0 00-1.155-.28h-2.949a2.534 2.534 0 00-2.533 2.531v6.635a.688.688 0 00.688.688h22.118a.688.688 0 00.688-.688v-4.792a2.534 2.534 0 00-2.531-2.531zm-19.585.688a1.156 1.156 0 011.155-1.155h2.949a1.156 1.156 0 011.155 1.155v5.947h-5.259zm6.635 0v-2.58a1.156 1.156 0 011.155-1.158h5.16a1.156 1.156 0 011.155 1.155v8.527h-7.47zm14.1 5.947h-5.253v-4.1a1.156 1.156 0 011.155-1.155h2.949a1.156 1.156 0 011.155 1.155z"
            data-name="Path 370"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgLeaderboard;
